import { Segment } from 'component/Space/Segment'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import Curvy from 'page/ProfileScreen/assets/curvy.svg'
import Normal from 'page/ProfileScreen/assets/normal.svg'
import PlusSize from 'page/ProfileScreen/assets/plus-size.svg'
import Skinny from 'page/ProfileScreen/assets/skinny.svg'
import Slim from 'page/ProfileScreen/assets/slim.svg'
import { FC, SVGProps } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { BodyIndex } from 'type/Identity'

type Props = {
  body: BodyIndex
}

function getSvg(body: BodyIndex): FC<SVGProps<any>> | undefined {
  if (body === 1) return Skinny
  if (body === 2) return Slim
  if (body === 3) return Normal
  if (body === 4) return Curvy
  if (body === 5) return PlusSize
}

function getLabel(body: BodyIndex): string | undefined {
  if (body === 1) return i18n('body.Skinny')
  if (body === 2) return i18n('body.Slim')
  if (body === 3) return i18n('body.Normal')
  if (body === 4) return i18n('body.Curvy')
  if (body === 5) return i18n('body.PlusSize')
}

export const BodySizeButton = observer(({ body }: Props) => {
  const { form } = store.profile
  const Svg = getSvg(body)
  const _label = getLabel(body)

  const onClick = useLatestCallback(() => {
    form.setBody(body)
  })

  const inner = <Vertical gap={2} pad={[0, 0, 0, 0]} center>
    {Svg && <Svg height={opt.basic ? 72 : opt.stand ? 60 : 40} width={undefined} />}
  </Vertical>

  return <Segment height={opt.basic ? 84 : opt.stand ? 72 : 48} active={form.body === body} action={onClick}>
    <span>{inner}</span>
  </Segment>
})
